/**
 * @file Maps browser `File` objects to API `DocumentFileType` for document upload payloads.
 * Shared helper for document upload adapters; not fully upload-framework-neutral.
 */

import { DocumentFileType } from '@/api/client';

/**
 * Infers API document file type from file name extension and MIME type.
 * Returns `UNDETERMINED` for unsupported types (e.g. ZIP, GIF, WEBP).
 * @param file - Browser File from dropzone or file picker.
 */
export const inferDocumentFileType = (file: File): DocumentFileType => {
  const lower = file.name.toLowerCase();
  const { type } = file;
  if (lower.endsWith('.pdf') || type === 'application/pdf') {
    return DocumentFileType.PDF;
  }
  if (
    lower.endsWith('.docx') ||
    type ===
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ) {
    return DocumentFileType.DOCX;
  }
  if (
    lower.endsWith('.xlsx') ||
    type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ) {
    return DocumentFileType.XLSX;
  }
  if (lower.endsWith('.png') || type === 'image/png') {
    return DocumentFileType.PNG;
  }
  if (
    lower.endsWith('.jpg') ||
    lower.endsWith('.jpeg') ||
    type === 'image/jpeg'
  ) {
    return DocumentFileType.JPG;
  }
  return DocumentFileType.UNDETERMINED;
};
